import { atom, atomFamily } from 'recoil'
import { fetchQuery } from './selectors'

export const taskQueueState = atom({
	key: 'taskQueue',
	default: [],
})

export const currentDetailLevelState = atom({
	key: 'currentDetailLevel',
	default: '',
})

export const currentTaskFormState = atom({
	key: 'currentTaskFormState',
	default: '',
})

export const opinionMetadataSelectedUserState = atom({
	key: 'opinionMetadataSelectedUserState',
	default: '',
})

export const openedTask = atom({
	key: 'openedTask',
	default: null,
})

export const openedRequisitionState = atom({
	key: 'openedRequisitionState',
	default: null,
})

export const inboxFiltersState = atom({
	key: 'inboxFilters',
	default: { branch: [], insuranceCompany: [] },
})

export const inboxHasNewDataState = atom({
	key: 'inboxHasNewData',
	default: false,
})

export const expandedInboxState = atom({
	key: 'expandedInbox',
	default: false,
})

export const expandedInboxWithSizeMediumState = atom({
	key: 'expandedInboxWithSizeMediumState',
	default: false,
})

export const forceInboxUpdateState = atom({
	key: 'forceInboxUpdate',
	default: false,
})

export const lastFetchUpdate = atomFamily({
	key: 'lastFetchUpdate',
	default: Date.now(),
})

export const nextTaskProcessId = atom({
	key: 'nextTaskProcessId',
	default: null,
})

export const lastFetchInboxUpdate = atom({
	key: 'lastFetchInboxUpdate',
	default: Date.now(),
})

export const debugState = atom({
	key: 'debugValue',
	default: 0,
})

export const fetchState = atomFamily({
	key: 'Fetch',
	default: fetchQuery,
})

export const searchProcessString = atom({
	key: 'searchProcessString',
	default: '',
})

export const expandedCommentsAtom = atom({
	key: 'expandedComments',
	default: false,
})

export const controllerFilters = atom({
	key: 'controllerFilters',
	default: {
		appointments: {
			filterValuesList: [],
			filters: { status: [], provider: [], specialty: [] },
		},
		requisitions: {
			filterValuesList: [],
			filters: { type: [] },
		},
	},
})

export const currentUserProcessPreferences = atom({
	key: 'currentUserProcessPreferences',
	default: {},
})

export const taskNote = atom({
	key: 'taskNote',
	default: '',
})
